<main class="error-container" aria-labelledby="error-title">
    <div class="error-content">
        <img src="images/logo2.png" alt="มกอช." class="logo" width="112" height="104">
        @if (errorCode !== null) {
            <h1 id="error-title">{{ errorCode }}</h1>
        }
        <h2 [attr.id]="errorCode === null ? 'error-title' : null">{{ errorTitle }}</h2>
        <p>{{ errorMessage }}</p>
        <div class="error-actions">
            <a [href]="portalUrl" class="btn btn-primary">กลับไปยังพอร์ทัล</a>
            @if (errorCode === null || errorCode === 401) {
                <button type="button" class="btn btn-outline-secondary" (click)="login()">
                    เข้าสู่ระบบอีกครั้ง
                </button>
            } @else {
                <button type="button" class="btn btn-outline-secondary" (click)="logout()"
                        [disabled]="isLoggingOut()" [attr.aria-busy]="isLoggingOut()">
                    {{ isLoggingOut() ? 'กำลังออกจากระบบ…' : 'ออกจากระบบ' }}
                </button>
            }
        </div>
    </div>
</main>
